import { render } from "./CustomLayout.vue?vue&type=template&id=e6f15464"
import script from "./CustomLayout.vue?vue&type=script&lang=js"
export * from "./CustomLayout.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__